import styled from "styled-components";
import React, { useState } from "react";

const CardWrapper = styled.div`
  width: 300px;
  height: auto;
  margin: 0 auto;
  margin-top: 40px;
  display: inline-block;
  border-radius: 10px;
  @media only screen and (max-width: 500px) {
    width: 250px;
  }
`;

const CardImg = styled.img`
  max-width: 200px;
  height: auto;
  @media only screen and (max-width: 500px) {
    width: 150px;
  }
`;

const Card = props => {
  const [myclass, setClass] = useState("card");

  return (
    <CardWrapper
      onMouseEnter={() => {
        setClass("card z-depth-5");
      }}
      onMouseLeave={() => {
        setClass("card");
      }}
      className={myclass}
    >
      <div className="card-content">
        <CardImg style={{ margin: "0 auto", marginBottom: "10px" }} src={props.imgurl} />
        <p
          style={{ fontSize: "15px", color: "#667988", fontWeight: "300", letterSpacing: "1.1px" }}
        >
          {props.body}
        </p>
      </div>
      <div style={{ height: "50px", borderRadius: "10px" }} className="card-action">
        <a style={{ float: "right", color: "#ea1821" }} href={props.news}>
          Read More →
        </a>
      </div>
    </CardWrapper>
  );
};

export default Card;
